// The words a SAVED Test's report boxes are read out by (TGCLOUD-1868, plan D6). Pure: no React.
//
// GET /test-results/:id/anchors gives each box the record's stable path (`lab`,
// `genesTested.BRCA2.coverage.status`, `variants.<findingId>.variantP`), which anchorLabels.js, made
// for a reading's paths by position, cannot name. The field is named by anchorLabels' own words, and
// the gene or the variant it belongs to is said by its symbol, or by `nameVariant(findingId)` (the
// Test's variant as a clinician names it, "MLH1 c.1852_1854del"), so a screen reader hears which
// value a box is ("Protein change, MLH1 c.1852_1854del, as read from the report"), in the caller's
// `t` (TGCLOUD-1893), English by default.
import { english } from 'src/i18n/language';
import { fieldOf } from './anchorLabels';

/**
 * @param {string} path a stable path
 * @param {{ nameVariant?: (findingId: string) => string|null, t?: Function }} [options]
 * @returns {string} the field's name, without the "as read from the report" the pane adds
 */
export function savedAnchorLabel(
  path,
  { nameVariant = null, t = english } = {}
) {
  const text = typeof path === 'string' ? path : '';
  const listed = /^(variants|genesTested)\.([^.]+)(?:\.(.+))?$/.exec(text);
  if (!listed) return fieldOf(text, {}, t).name;
  const [, list, key, rest] = listed;
  const { name } = fieldOf(`${list}.0${rest ? `.${rest}` : ''}`, {}, t);
  let which = key;
  if (list === 'variants') {
    const named = typeof nameVariant === 'function' ? nameVariant(key) : null;
    which = typeof named === 'string' && named.trim() ? named.trim() : null;
  }
  return which ? `${name}, ${which}` : name;
}
